import api from "./api";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function catcherror(error) {
  console.log(error);
  // Silently ignore timeout errors — no toast shown
  if (error.code === 'ECONNABORTED' || (error.message && error.message.toLowerCase().includes('timeout'))) {
    return;
  }
  if (!error.response) {
    toast.error(error.message || "Network error. Please check your connection.");
    return;
  }
  if (error.response.status === 401) {
    localStorage.clear();
    <Navigate to={"/login"} />;
  } else if (error.response.status === 422) {
    Swal.fire({
      title: "There are few errors occurred while processing the request.",
      showCancelButton: false,
      confirmButtonColor: "#6259ca",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    });
  }
}

// ── Account Groups ───────────────────────────────────────────

export async function accountGroupCreate(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/createaccountgroup", data, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function accountGroupList(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/listaccountgroup", data, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function accountGroupView(id) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.get(`/viewaccountgroup/${id}`, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function accountGroupDelete(id) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.get(`/deleteaccountgroup/${id}`, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

// ── Ledger Master ────────────────────────────────────────────

export async function ledgerCreate(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/createledger", data, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function ledgerList(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/listledger", data, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function ledgerView(id) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.get(`/viewledger/${id}`, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function ledgerDelete(id) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.get(`/deleteledger/${id}`, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

// ── Voucher Entry ────────────────────────────────────────────

export async function voucherCreate(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" };
    return await api.post("/createvoucher", data, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function voucherList(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/listvoucher", data, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function voucherView(id) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.get(`/viewvoucher/${id}`, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function voucherDelete(id) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.get(`/deletevoucher/${id}`, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

// ── Reports ──────────────────────────────────────────────────

export async function dayBookReport(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/daybook", data, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function ledgerReport(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/ledgerreport", data, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function trialBalanceReport(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/trialbalance", data, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function profitLossReport(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/profitloss", data, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}

export async function balanceSheetReport(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/balancesheet", data, { headers: header })
      .then((res) => res.data).catch((err) => catcherror(err));
  } catch (e) { catcherror(e); }
}
